import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const funcionalidades = {
  PARAMETROS_CERTIFICADO_DIGITAL: {
    descricao: 'O Certificado digital precisa estar configurado.',
    path: 'Configurações > Parâmetros > Nota Fiscal > Certificado digital',
  },
  PARAMETROS_CERTIFICADO_DIGITAL_VALIDADE: {
    descricao: 'O Certificado digital precisa estar dentro da validade.',
    path: 'Configurações > Parâmetros > Nota Fiscal > Certificado digital',
  },
  PARAMETROS_NFSE_PREFEITURA: {
    descricao: 'É preciso informar login e/ou senha da prefeitura',
    path: 'Configurações > Parâmetros > Nota Fiscal > NFS-e',
  },
  INFORMACOES_EMPRESA: {
    descricao: 'As informações a seguir, referentes à empresa, ',
    path: 'Nome do usuário no cabeçalho > Minha empresa',
  },
  INFORMACOES_CLIENTE: {
    descricao: 'As informações a seguir, referentes ao cliente, ',
    path: 'Vendas e Serviços > Clientes',
  },
  INFORMACOES_PRODUTO: {
    descricao: 'As informações a seguir, referentes aos produtos, ',
    path: 'Suprimentos > Produtos',
  },
  INFORMACOES_SERVICO: {
    descricao: 'As informações a seguir, referentes aos serviços, ',
    path: 'Vendas e Serviços > Serviços',
  },
  INFORMACOES_FORNECEDOR: { descricao: 'Informações do fornecedor', path: 'Suprimetos > Fornecedores' },
  INFORMACOES_DESTINATARIO: { descricao: 'Informações do cliente', path: 'Vendas e serviços > Clientes' },
};

const campos = {
  CPF_CNPJ: 'CPF/CNPJ',
  NOME_RAZAO_SOCIAL: 'Razão social',
  ENDERECO: 'Endereço',
  INSCRICAO_MUNICIPAL: 'Inscrição municipal',
  REG_TRIB: 'Regime tributário',
  REG_TRIB_ESPECIAL: 'Regime tributário especial',
  PIS: 'PIS',
  COFINS: 'COFINS',
  COD_NCM: 'Código NCM',
  IPI: 'IPI',
  COD_LEI_COMP_116: 'Código de Lei Complementar 116',
  COD_TRIB_NACIONAL: 'Código de tributação nacional',
  ISS: 'ISS',
  CFOP: 'CFOP',
  ICMS: 'ICMS',
  ALIQUOTA_PIS: 'Alíquota do PIS',
  ALIQUOTA_COFINS: 'Alíquota do COFINS',
};

const FaturamentoVisualizar = ({ pendencias }) => {
  return (
    <>
      <Grid container spacin={3}>
        <Grid item xs={12} className="mb-16">
          <Typography style={{ fontWeight: 'bold' }}>
            Para faturar, é necessário que as informações abaixo estejam devidamente preenchidas:
          </Typography>
        </Grid>
        {pendencias?.map((item, i) => (
          <Grid item xs={12} className="mb-16">
            <Typography>
              {`${i + 1} - `}
              {funcionalidades[item.funcionalidade].descricao.includes('O Certificado')
                ? funcionalidades[item.funcionalidade].descricao
                : funcionalidades[item.funcionalidade].descricao.includes(
                    funcionalidades.PARAMETROS_NFSE_PREFEITURA.descricao
                  )
                ? `${funcionalidades[item.funcionalidade].descricao}:`
                : `${funcionalidades[item.funcionalidade].descricao} devem estar cadastradas:`}
            </Typography>
            <div className="mt-16 mb-16">
              {item?.camposDto?.map((campo) => (
                <>
                  {campo?.nome && (
                    <Grid item xs={12}>
                      <Typography style={{ fontWeight: 'bold' }}>{campo.nome}:</Typography>
                    </Grid>
                  )}
                  {campo?.campos.map((c) => (
                    <Grid item xs={12}>
                      <Typography>- {campos[c]}</Typography>
                    </Grid>
                  ))}
                </>
              ))}
            </div>
            <Typography>Acesse: {funcionalidades[item.funcionalidade].path}</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default FaturamentoVisualizar;
